module.exports = __webpack_public_path__ + "static/Vyucni_list-48adffb74d0478c84a82a6e4c40336e9.png";